var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyBets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:66.67px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M566.67,433.34H700v200A66.66,66.66,0,0,1,633.33,700M566.67,433.34v200A66.65,66.65,0,0,0,633.33,700M566.67,433.34V191.91c0-30.18,0-45.27-6.34-54a33.35,33.35,0,0,0-23.41-13.59c-10.74-1.16-23.84,6.33-50,21.3l-10.41,6c-9.64,5.51-14.47,8.27-19.59,9.35a33.48,33.48,0,0,1-13.74,0c-5.12-1.08-9.95-3.84-19.59-9.35l-63.75-36.43c-9.64-5.51-14.46-8.26-19.58-9.34a33.18,33.18,0,0,0-13.75,0c-5.12,1.08-9.94,3.83-19.59,9.34l-63.74,36.43c-9.65,5.51-14.47,8.27-19.59,9.35a33.53,33.53,0,0,1-13.75,0c-5.12-1.08-9.94-3.84-19.58-9.35l-10.42-6c-26.2-15-39.3-22.46-50-21.3a33.33,33.33,0,0,0-23.41,13.59c-6.34,8.75-6.34,23.84-6.34,54V540c0,56,0,84,10.9,105.4a99.93,99.93,0,0,0,43.7,43.7C176,700,204,700,260,700H633.33m-400-266.66H300M233.33,300h200m-200,266.67H300m133.33,0h.34m-.34-133.33h.34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyBets);
export default __webpack_public_path__ + "static/media/MyBets.8c7c3e42832d6a35cbe317f3f0924f49.svg";
export { ForwardRef as ReactComponent };